import { useContext } from "react";
import { DynamicFormContext } from "./DynamicFormContext";

export function useDynamicForm() {
  const context = useContext(DynamicFormContext);
  if (!context) {
    throw new Error(
      "useDynamicForm must be used within a <DynamicFormContextProvider>"
    );
  }
  return context;
}
